import axios from 'axios';

const instance = axios.create({
  baseURL: window.location.origin,
  // host: window.location.host,
  connectTimeout: 180000,
  timeout: 360000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
    // WithCredentials: true,
    // Credentials: 'include'
  },
  responseType: "json",
  withCredentials: true
});

export default {
  setAuthToken(token) {
    if (token) {
      // If a token is present, set the Authorization header
      instance.defaults.credentials = 'include'
      instance.defaults.headers.common['Authorization'] = "Bearer " + token;
    } else {
      // If no token is provided, delete the Authorization header
      delete instance.defaults.headers.common['Authorization'];
    }
  },

  request(options) {
    return instance.request(options);
  }
}
